import api from './client';
import type { PartnerInfos } from 'types';

export const partnersApi = {
  list: async (params?: { org_id?: string; company_type?: string; limit?: number; offset?: number; sort_by?: string; sort_dir?: string }): Promise<PartnerInfos[]> => {
    const { data } = await api.get('/partners', { params });
    return data;
  },

  get: async (partnerId: string): Promise<PartnerInfos> => {
    const { data } = await api.get(`/partners/${partnerId}`);
    return data;
  },

  create: async (partner: Omit<PartnerInfos, 'id'> & { org_id: string }): Promise<PartnerInfos> => {
    const { data } = await api.post('/partners', partner);
    return data;
  },

  update: async (partnerId: string, updates: Partial<PartnerInfos>): Promise<PartnerInfos> => {
    const { data } = await api.patch(`/partners/${partnerId}`, updates);
    return data;
  },

  checkDuplicate: async (params: { org_id: string; company_name?: string; email?: string; company_email?: string }): Promise<{
    status: "available" | "similar" | "exact";
    matches: Array<{ id: string; company_name: string; display_name: string; email: string; phone_number: string; company_types: string[] }>;
  }> => {
    const { data } = await api.get('/partners/check-duplicate', { params });
    return data;
  },

  delete: async (partnerId: string): Promise<void> => {
    await api.delete(`/partners/${partnerId}`);
  },

  uploadDecennale: async (partnerId: string, year: number, file: globalThis.File): Promise<PartnerInfos> => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post(`/partners/${partnerId}/decennale/${year}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  deleteDecennale: async (partnerId: string, year: number): Promise<PartnerInfos> => {
    const { data } = await api.delete(`/partners/${partnerId}/decennale/${year}`);
    return data;
  },
};
